export const selectAddProductModalOpened = state => state.addproductmodalopened;
